import React from 'react';
import * as Icons from 'lucide-react';
import { admissionSteps } from '../mock/data';
import { useReveal } from '../hooks/useReveal';
import { ArrowRight } from 'lucide-react';

function Step({ s, i }) {
  const { ref, inView } = useReveal();
  const Icon = Icons[s.icon] || Icons.CheckCircle2;
  return (
    <div ref={ref} style={{ transitionDelay: `${i * 120}ms` }} className={`reveal ${inView ? 'in-view' : ''} relative flex-1 min-w-[210px]`}>
      <div className="lift rounded-2xl bg-white border border-[var(--pca-border)] p-6 h-full text-center">
        <div className="mx-auto w-14 h-14 rounded-2xl bg-[var(--pca-blue-soft)] text-[var(--pca-blue)] flex items-center justify-center">
          <Icon size={22} />
        </div>
        <div className="mt-4 text-[12px] font-bold tracking-[2px] text-slate-400">{s.num}</div>
        <h4 className="mt-1 font-bold text-[#0B2E6E]">{s.title}</h4>
        <p className="mt-2 text-slate-600 text-sm">{s.desc}</p>
      </div>
    </div>
  );
}

export default function Admission() {
  const { ref, inView } = useReveal();
  return (
    <section id="admissions" className="py-20 md:py-28 bg-[var(--pca-blue-tint)]">
      <div className="container-x">
        <div ref={ref} className={`reveal ${inView ? 'in-view' : ''} text-center max-w-2xl mx-auto`}>
          <span className="section-eyebrow">HOW TO JOIN</span>
          <h2 className="section-title mt-4 text-[34px] md:text-[44px] leading-tight">A simple 5-step admission process</h2>
          <p className="mt-4 text-slate-600">Getting admitted to Pharmacy College Azamgarh is straightforward and student-friendly.</p>
        </div>

        <div className="mt-12 flex flex-wrap justify-center gap-5">
          {admissionSteps.map((s, i) => <Step key={s.num} s={s} i={i} />)}
        </div>

        <div className="mt-10 text-center">
          <a href="#contact" className="btn-primary">Start Your Application <ArrowRight size={16} /></a>
        </div>
      </div>
    </section>
  );
}
